import { defineComponent as _defineComponent } from 'vue'
import ProductCarouselViewObject = Vertica.LouisPoulsen.Application.Commerce.ViewModels.ProductCarouselViewObject;
import { computed, watch, ref, Ref } from 'vue';
import { store } from '@/store';
import { useSwiper, ManagedSwiper, SwiperNavigationButton, Swiper } from '@/ui/shared/swiper';
import AutoOptimizedImage from '@/ui/shared/image/auto-optimized-image/AutoOptimizedImage.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductCarousel',
  props: {
    title: null,
    products: null,
    link: null,
    linkText: null
  },
  setup(__props: any) {

const props = __props as {
    title?: string,
    products: ProductCarouselViewObject[],
    link?: LinkViewObject,
    linkText?: string
}



const productsRef: Ref<ProductCarouselViewObject[]> = ref(props.products);
watch(() => props.products, () => {
    productsRef.value = props.products;
});

const updateSlidesPerGroupToNumVisibleSlides = (swiper: Swiper) => {
    const containerWidth = swiper.el.clientWidth;
    const slideWidth = 295;
    const numVisibleSlides = Math.floor(containerWidth / slideWidth);
    if (swiper.params) {
        if (swiper.params.slidesPerGroup !== numVisibleSlides) {
            swiper.params.slidesPerGroup = numVisibleSlides;
            swiper.update();
        }
    }
};

const { swiperManager } = useSwiper<ProductCarouselViewObject>({
    slides: productsRef,
    swiperOptions: {
        loop: false,
        slidesPerView: 'auto',
        centeredSlides: false,
        slidesPerGroup: 2,
        on: {
            resize: (swiper: Swiper) => {
                updateSlidesPerGroupToNumVisibleSlides(swiper);
            }
        }
    }
});

const textColor = computed<OpacityFunction>(() => store.getters['app/textColor']);

const theme = computed<ColorTheme>(() => store.getters['app/theme']);

function backgroundColor(product: ProductCarouselViewObject): string {
    return theme.value.productTileBackgroundColor ? theme.value.productTileBackgroundColor : product.backgroundColor;
}

return { __sfc: true,props, productsRef, updateSlidesPerGroupToNumVisibleSlides, swiperManager, textColor, theme, backgroundColor, ManagedSwiper, SwiperNavigationButton, AutoOptimizedImage }
}

})